import React, {ReactNode} from 'react'

import type {PopupRef} from '../UI/overlays/Popup.js'
import VerificationCodeInput from '../UI/forms/VerificationCodeInput.js'
import t from '../../helpers/Languages.js'

export interface MfaPopupOptions {
    /** 'app' or 'email', for the explanation above the code */
    mfaMethod?: string
    /**
     * Called with the code on confirm. The popup stays open with a spinner until the caller sets an error
     * (popup.setError), shows showMfaContinue or closes it.
     */
    onLogin: (code: string) => void
    /** Instead of Inloggen */
    confirmLabel?: ReactNode
    /** On every close, also after showMfaContinue */
    onClose?: () => void
}

/** Asks for the two-factor code in popup */
export function openMfaPopup(popup: PopupRef, {mfaMethod, onLogin, confirmLabel, onClose}: MfaPopupOptions) {
    popup.setInput({
        type: 'custom',
        name: 'code',
        value: '',
        render: (value, onChange, {disabled}) => (
            <VerificationCodeInput
                disabled={disabled}
                onChange={(code) => {
                    // The error replaces the confirm button by Sluiten, a new code brings it back
                    popup.setError('')
                    onChange(code.join(''))
                }}
            />
        )
    })
    popup.setConfirmLabel(confirmLabel || t('mfaLogIn'))

    popup.open(
        t('mfaTitle'),
        mfaMethod === 'app' ? t('mfaEnterCodeApp') : mfaMethod === 'email' ? t('mfaEnterCodeEmail') : t('mfaEnterCode'),
        (code) => onLogin(code || ''),
        onClose
    )
}

/**
 * After a verified code: asks for one more click to continue in the popup of openMfaPopup, for what browsers only
 * allow in a click (e.g. opening a new tab). onContinue is called inside that click, then the popup closes.
 */
export function showMfaContinue(popup: PopupRef, text: ReactNode, buttonLabel: ReactNode, onContinue: () => void) {
    popup.setInputs([])
    popup.openAlert(t('mfaTitle'), text, {actionLabel: buttonLabel, onAction: onContinue})
}
